import React from 'react';

import get from 'lodash/get';
import uniq from 'lodash/uniqBy';

import {
  SidePage,
  Link,
  DescriptionList,
  DescriptionItem,
  Section,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { UpdateInfluencer } from 'scenes/Influencers/InfluencersChannels/components/InfluencerForm';
import {
  useLoadInfluencerDetails,
  useIsUpdating,
} from 'scenes/Influencers/InfluencersChannels/data';

import InfluencerActions from '../Actions';

function pickUniq(prop) {
  return function (arr) {
    return uniq(
      arr.reduce((m, o) => {
        const v = o[prop]?.name;
        if (v !== undefined) {
          return [...m, o[prop]?.name];
        }
        return m;
      }, [])
    ).join(', ');
  };
}

const InfluencerDetails = ({ id, onClose, onExited, open }) => {
  const { data, isLoading, isRefetching } = useLoadInfluencerDetails(id);

  const [childComponent, openChildComponent] = useChildComponent();
  const isUpdating = useIsUpdating();

  const handleEdit = (initialValues) => {
    openChildComponent(UpdateInfluencer, { initialValues });
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'Influencer'}
        subTitle={get(data, 'name')}
        entityId={id}
      />
      <SidePage.NewBody wrapper={true}>
        {childComponent}
        <SidePage.NewContent>
          <Section title={'General'}>
            <DescriptionList disableGutters data={data}>
              <DescriptionItem
                label={'Categories'}
                field={'influencerChannels'}
                valueParser={pickUniq('category')}
              />
              <DescriptionItem
                label={'Subcategories'}
                field={'influencerChannels'}
                valueParser={pickUniq('subCategory')}
              />
            </DescriptionList>
          </Section>
          <Section
            title={`Influencer Channels (${data?.influencerChannels?.length})`}
            isCollapsable
            initialOpen={true}
          >
            <TableContainer>
              <Table>
                <TableBody>
                  {data?.influencerChannels?.map((channel) => (
                    <TableRow>
                      <TableCell>
                        <Link href={channel.link} target={'_blank'}>
                          {channel.link}
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Section>
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            <InfluencerActions
              actions={data?.actions}
              data={data}
              onEdit={handleEdit}
            />
          }
        >
          <DescriptionList
            variant={'column'}
            data={data}
            stripEmpty={true}
            disableGutters={true}
          >
            <DescriptionItem label={'Owner'} field={'owner.name'} />
            <DescriptionItem
              label={'Last updated by'}
              type={'metadata'}
              field={'metadata'}
              userField={'updatedBy'}
              dateField={'updated'}
            />
            <DescriptionItem
              label={'Created by'}
              type={'metadata'}
              field={'metadata'}
              userField={'createdBy'}
              dateField={'created'}
            />
          </DescriptionList>
        </SidePage.Sidebar>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default InfluencerDetails;
